<template>
	<v-app id="app">
		<Background :color="backgroundColor"/>
		<div class="app-wrap">
			<Loading v-if="!loaded" />
			<div v-else>
				<v-fade-transition mode="out-in">
					<router-view />
				</v-fade-transition>
			</div>
		</div>
	</v-app>
</template>
<script>
import Background from '@/components/Background.vue';
//import ToggleAudio from '@/components/ToggleAudio.vue';
import Loading from '@/components/Loading.vue';

export default {
	components: {Background,/*ToggleAudio,*/ Loading},
	data() {
		return {
			loaded: false,
		}
	},
	computed: {
		backgroundColor: {
			get() {
				return this.$store.state.backgroundColor;
			},
			set(newValue) {
				this.updateProperty({
					property: "backgroundColor",
					value: newValue
				});
			}
		}
	},
	methods: {
		checkWord(element) {
			if(!element.word || !typeof element.word === 'string' || element.word.length < 3) return false;
			return true;
		},
	},
	async mounted() {
		let results = await this.axios.get('data_storie.tsv');
		let read = this.$papa.parse(results.data, {
			header: true,
			delimiter: "\t"
		});
		let dictionaryRaw = await read.data.filter(el => {
			return (el['word'] && el['word'].length);
		});
		/*
		dictionaryRaw = await read.data.map(el => {
			console.log(el);
			el['word'] = el['LEMMA'];
			el['type'] = el['CATEGORIA_GRAMMATICALE'].toLowerCase();
			el['source'] = el['COMPLESSITA_LESSICALE'];
			return el;
		});*/


		let dictionary = dictionaryRaw.filter(el => {
			return this.checkWord(el);
		});

		this.updateProperty({
			property: 'dictionary',
			value: dictionary
		});

		this.loaded = true;
	}
}
</script>
<style lang="scss">
	.loading {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: $blue;
		z-index:19999;
	}
	.app-wrap {
		/* padding-top: px(30);
		@include breakpoint(s) {
			padding-top: px(15);
		}*/
	}
</style>